import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SURFACE } from "../common/designTokens";

export interface KpiItem {
  label: string;
  value: string;
  sub?: string;
  /** `warn` draws the tile amber (ขาด-เกิน's เกิน). */
  tone?: "warn";
}

const WARN = { bg: "#FFF4E3", border: "#F1D9AE", fg: "#6B4A10" } as const;

/** A row of figure tiles (prototype `.kpis`); wraps on narrow screens. */
export default function KpiRow({ items }: Readonly<{ items: KpiItem[] }>) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
        gap: 1.5,
      }}
    >
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{
            bgcolor: item.tone === "warn" ? WARN.bg : SURFACE.card,
            border: `1px solid ${item.tone === "warn" ? WARN.border : SURFACE.line}`,
            borderRadius: SURFACE.radius,
            px: 1.75,
            py: 1.5,
          }}
        >
          <Typography variant="caption" sx={{ color: item.tone === "warn" ? WARN.fg : SURFACE.tx2 }}>
            {item.label}
          </Typography>
          <Typography sx={{ fontSize: "1.375rem", fontWeight: 600, lineHeight: 1.3 }}>
            {item.value}
          </Typography>
          {item.sub && (
            <Typography variant="caption" sx={{ color: item.tone === "warn" ? WARN.fg : SURFACE.tx2 }}>
              {item.sub}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
